import {useState, useEffect} from 'react'
// import {useGetCurrentUserQuery} from 'store/Store'
import storage from './storage'
// import {Images} from 'appearance'

export * from 'react'
export {useNavigate} from 'react-router-dom'
export {useDispatch} from 'react-redux'
export {redirect} from 'react-router-dom'

// export const useWindowSize = () => {
//     const isClient = typeof window === 'object'

//     const getSize = () => {
//         return {
//             width: isClient ? window.innerWidth : undefined,
//             height: isClient ? window.innerHeight : undefined,
//         }
//     }

//     const [windowSize, setWindowSize] = useState(getSize)

//     useEffect(() => {
//         if (!isClient) {
//             return false
//         }

//         function handleResize() {
//             setWindowSize(getSize())
//         }

//         window.addEventListener('resize', handleResize)
//         return () => window.removeEventListener('resize', handleResize)
//     }, [isClient])

//     return windowSize
// }

const getUrlParamsObject = () => {
    const searchParams = new URLSearchParams(window.location.search)
    const params = {}
    searchParams.forEach((v, k) => (params[k] = v))
    return params
}

const updateUrl = (key, val, _refresh = false) => {
    const searchParams = new URLSearchParams(window.location.search)
    if (!val) {
        searchParams.delete(key)
    } else {
        searchParams.set(key, val)
    }
    const newUrl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?' +
        searchParams.toString()

    if (window.history.pushState) {
        window.history.pushState({path: newUrl}, '', newUrl)
    }
    return searchParams.toString()
}

export const useUrlParams = () => {
    const [urlParams, setUrlParams] = useState(getUrlParamsObject)

    useEffect(() => {
        function handleUrlChange() {
            setUrlParams(getUrlParamsObject())
        }
        setUrlParams(getUrlParamsObject())
        window.addEventListener('popstate', handleUrlChange)

        return () => window.removeEventListener('popstate', handleUrlChange)
    }, [])

    const setUrlParam = (key, value) => {
        updateUrl(key, value)
        window.dispatchEvent(new Event('popstate'))
    }

    return {urlParams, setUrlParam}
}

export const useUpdatedAccountImage = () => {
    const locallySavedImage = storage.getAccountImage()
    // const {data: userToken} = useGetCurrentUserQuery()
    // const {data: user} = useGetUserQuery({userId: userToken?._id})
    // const userImage = user?.profileImageUrl

    if (locallySavedImage) {
        return locallySavedImage
    }
    // if (userImage) {
    //     return userImage
    // }
    // return Images.USER_DEFUALT
}

export const getLayoutDirection = (isRtl) => (isRtl ? 'rtl' : 'ltr')
